import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import BuyCrypto from "../components/dashboard/BuyCrypto";
import Loader from "../components/Loader";
import Funding from "../components/stocks/Funding";

function Buy({ user }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getDoc(doc(db, "users", "buy"));
      } catch (error) {
        console.error("Error fetching buy data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCloseModal = () => {
    navigate("/fxt");
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="skyfxt-box fxt-deposit">
      <BuyCrypto
        loading={loading}
        handleCloseModal={handleCloseModal}
        user={user}
      />
      <Funding />
    </div>
  );
}

export default Buy;